import { render, staticRenderFns } from "./EditColumnOrder.vue?vue&type=template&id=7ef0bb39&"
import script from "./EditColumnOrder.vue?vue&type=script&lang=js&"
export * from "./EditColumnOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditColumnOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports